export const config = {
    apiKey: "AIzaSyC2yvjEwJduTjJ7p1wgoBueK4_t63OM_kg",
    authDomain: "joelaphoto-44d21.firebaseapp.com",
    databaseURL: "https://joelaphoto-44d21.firebaseio.com",
    projectId: "joelaphoto-44d21",
    storageBucket: "joelaphoto-44d21.appspot.com",
    messagingSenderId: "656667570983",
    appId: "1:656667570983:web:88e8b4217f67f511146f02"
};